var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { State, Store, Action, Selector } from '@ngxs/store';
import { SetProgress } from './engine.progress.actions';
var initialState = {
    storyLoadProgress: 0,
    chunkLoadProgress: 0
};
var EngineProgressState = /** @class */ (function () {
    function EngineProgressState(store) {
        this.store = store;
    }
    EngineProgressState.getStoryLoadProgress = function (state) {
        return state.storyLoadProgress;
    };
    EngineProgressState.getChunkLoadProgress = function (state) {
        return state.chunkLoadProgress;
    };
    EngineProgressState.prototype.setProgress = function (context, action) {
        context.patchState({
            storyLoadProgress: action.storyLoadProgress,
            chunkLoadProgress: action.chunkLoadProgress
        });
    };
    __decorate([
        Action(SetProgress),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SetProgress]),
        __metadata("design:returntype", void 0)
    ], EngineProgressState.prototype, "setProgress", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], EngineProgressState, "getStoryLoadProgress", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], EngineProgressState, "getChunkLoadProgress", null);
    EngineProgressState = __decorate([
        State({
            name: 'engineProgress',
            defaults: initialState
        }),
        __metadata("design:paramtypes", [Store])
    ], EngineProgressState);
    return EngineProgressState;
}());
export { EngineProgressState };
